(function () {
  'use strict';

  var mobileToggle = document.getElementById('mobile-toggle');
  var mainNav = document.getElementById('primary-nav');
  var dropdowns = document.querySelectorAll('.has-dropdown');

  mobileToggle.addEventListener('click', function () {
    mainNav.classList.toggle('active');
    mobileToggle.classList.toggle('active');
  });

  dropdowns.forEach(function (item) {
    var link = item.querySelector(':scope > a');
    link.addEventListener('click', function (e) {
      if (window.innerWidth <= 1024) {
        e.preventDefault();
        item.classList.toggle('open');
      }
    });
  });

  var track = document.querySelector('.testimonial-track');
  var slides = document.querySelectorAll('.testimonial-slide');
  var prevBtn = document.querySelector('.carousel-prev');
  var nextBtn = document.querySelector('.carousel-next');
  var dotsContainer = document.getElementById('carousel-dots');
  var currentSlide = 0;
  var totalSlides = slides.length;

  slides.forEach(function (_, i) {
    var dot = document.createElement('button');
    dot.classList.add('dot');
    if (i === 0) dot.classList.add('active');
    dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
    dot.addEventListener('click', function () {
      goToSlide(i);
    });
    dotsContainer.appendChild(dot);
  });

  function goToSlide(index) {
    if (index < 0) index = totalSlides - 1;
    if (index >= totalSlides) index = 0;
    currentSlide = index;
    track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
    updateDots();
  }

  function updateDots() {
    var dots = dotsContainer.querySelectorAll('.dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('active', i === currentSlide);
    });
  }

  prevBtn.addEventListener('click', function () {
    goToSlide(currentSlide - 1);
  });

  nextBtn.addEventListener('click', function () {
    goToSlide(currentSlide + 1);
  });

  var autoPlayInterval = setInterval(function () {
    goToSlide(currentSlide + 1);
  }, 6000);

  var carousel = document.getElementById('testimonial-carousel');
  carousel.addEventListener('mouseenter', function () {
    clearInterval(autoPlayInterval);
  });

  carousel.addEventListener('mouseleave', function () {
    autoPlayInterval = setInterval(function () {
      goToSlide(currentSlide + 1);
    }, 6000);
  });

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
})();
